import { Injectable } from '@angular/core';
import { AppSettingsService } from '../config/config-service';

@Injectable({ providedIn: 'root' })
export class ImageUrlService {
  constructor(private appSettings: AppSettingsService) {}

  buildUrl(key?: string | null): string {
    if (!key) return '';
    // If already an absolute URL or object URL, return as-is
    const lower = key.toLowerCase();
    if (lower.startsWith('http://') || lower.startsWith('https://') || lower.startsWith('data:') || lower.startsWith('blob:')) {
      return key;
    }
    const base = this.appSettings.getSettings().imagePreviewUrl || '';
    if (!base) return key; // fallback: return key as-is
    // normalize slashes
    const hasTrailing = base.endsWith('/');
    const hasLeading = key.startsWith('/');
    const path = hasTrailing && hasLeading ? key.substring(1) : (!hasTrailing && !hasLeading ? `/${key}` : key);
    return `${base}${path}`;
  }
}
